import PestRewardJSON from './PestReward.json';
console.log("CropInsurance ABI:", PestRewardJSON.abi);
export const PestRewardABI = PestRewardJSON.abi;